import { Link } from "react-router-dom"
import DynamicImage from "../common/DynamicImage"
import { renderText } from "../common/renderText"
import { HighlightText } from "../common/HighlightText"


const Banner = ({hero}) => {  

  return (
    <>
      <div className="it-services-banner overflow-hidden">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-7 col-md-12">
              <div className="main-banner-content text-start">
                {hero.heading && (
                <h1
                  data-aos="fade-right"
                  data-aos-duration="1200"
                  data-aos-delay="100"
                  // className="highlight-text"
                >
                  {/* {hero.heading} */}
                  <HighlightText content={hero.heading} />
                </h1>
                )}
                {hero.subheading && (
                <p
                  data-aos="fade-right"
                  data-aos-duration="1200"
                  data-aos-delay="200"
                  className="ms-0 mb-0"
                >
                   {hero.subheading}
                </p>
                )}
                {hero.descriptions && (
                <div className="overview-box">
                  <div className="overview-content">
                    <div className="content">
                      {hero?.descriptions?.map((block, index) => {
                                        switch (block.type) {
                                          case "paragraph":
                                            return (
                                              <p key={index}>{renderText(block.children)}</p>
                                            );
                      
                                          case "heading":
                                            const Tag = `h${block.level}`;
                                            return (
                                              <Tag key={index} className="mt-4 mb-3">
                                                {block.children.map(c => c.text).join("")}
                                              </Tag>
                                            );
                      
                                          case "list":
                                            return (
                                              <ul key={index} className="list-unstyled">
                                                {block.children.map((item, i) => (
                                                  <li key={i} className="features-text">
                                                    <h4>
                                                      <i className="flaticon-tick"></i>{" "}
                                                      {item.children.map(c => c.text).join("")}
                                                    </h4>
                                                  </li>
                                                ))}
                                              </ul>
                                            );
                      
                                          default:
                                            return null;
                                        }
                      })}
                    </div>
                  </div>
                </div>
                )}

                <div
                  className="btn-box"
                  data-aos="fade-left"
                  data-aos-duration="1200"
                  data-aos-delay="300"
                >
                  {hero.primaryButtonText && (
                    <Link to={`/${hero.primaryButtonLink}`} className="default-btn">
                      <i className="flaticon-right"></i>
                      {hero.primaryButtonText}
                      <span className="default-btn-hover"></span>
                    </Link>
                  )}
                  {hero.secondaryButtonText && (
                    <Link to="#" onClick={(e) => e.preventDefault()} className="default-btn">
                      <i className="flaticon-right"></i>
                      {hero.secondaryButtonText}
                      <span className="default-btn-hover"></span>
                    </Link>
                  )}
                </div>
              </div>
            </div>

            <div className="col-lg-5 col-md-12">
              <div
                className="main-banner-image"
                data-aos="fade-up"
                data-aos-duration="1200"
                data-aos-delay="400"
              >
                {hero?.heroImage?.url && <DynamicImage image={hero.heroImage} />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Banner
